import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propFunc, propStr } from '../../../helpers/custom-prop-types';
import { compose } from '../../../helpers/recompose';
import LoginButton from '../../Ui/Login/LoginButton';
import ModalHoc from '../../Ui/Modal/ModalHoc';
import RegistrationLink from '../../Ui/Registration/RegistrationLink';
const LoginAlertModalInner = (props) => {
    const { modalState, onClickClose } = props;
    return (_jsxs("div", Object.assign({ className: `fade_modal column_login_alert_modal ${modalState}` }, { children: [_jsx("div", { className: 'bg', onClick: onClickClose, role: 'presentation' }), _jsxs("div", Object.assign({ className: 'column_login_alert_modal_content' }, { children: [_jsx("h5", Object.assign({ className: 'title' }, { children: "\u4F1A\u54E1\u767B\u9332\u307E\u305F\u306F\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u304F\u3060\u3055\u3044" })), _jsx("p", Object.assign({ className: 'description' }, { children: "\u4F1A\u54E1\u767B\u9332\u3059\u308B\u3068\u3001\u4FDD\u5B58\u3057\u305F\u8A18\u4E8B\u306B\u3059\u3050\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u3001\u9650\u5B9A\u516C\u958B\u306E\u8A18\u4E8B\u3082\u8AAD\u3081\u307E\u3059\u3002" })), _jsxs("div", Object.assign({ className: 'button_box' }, { children: [_jsx(RegistrationLink, { className: 'button primary' }), _jsx(LoginButton, Object.assign({ className: 'button service' }, { children: "\u30ED\u30B0\u30A4\u30F3" }))] }))] }))] })));
};
LoginAlertModalInner.propTypes = {
    modalState: propStr().isRequired,
    onClickClose: propFunc().isRequired,
};
const enhance = compose(ModalHoc);
const LoginAlertModal = enhance(LoginAlertModalInner);
LoginAlertModal.propTypes = {
    isShow: propBool().isRequired,
    onClickClose: propFunc().isRequired,
};
export default LoginAlertModal;
